import './SkeletonForm.css';
import { Skeleton } from './Skeleton';

export type SkeletonFormProps = {
    fields?: number;
    hasActions?: boolean;
    className?: string;
};

export function SkeletonForm({
    fields = 5,
    hasActions = true,
    className = '',
}: SkeletonFormProps) {
    return (
        <section
            className={`skeleton-form ${className}`}
            role="status"
            aria-busy="true"
            aria-label="Loading form"
        >
            {Array.from({ length: fields }, (_, i) => (
                <div key={i} className="skeleton-form__field">
                    <Skeleton width="28%" height="12px" />
                    <Skeleton width="100%" height="44px" borderRadius="10px" />
                </div>
            ))}
            {hasActions && (
                <div className="skeleton-form__actions">
                    <Skeleton width="104px" height="40px" shape="pill" />
                    <Skeleton width="120px" height="40px" shape="pill" />
                </div>
            )}
        </section>
    );
}
